import React from 'react';
import '../App.css';

export default function Footer() {
  return (
    <div className='footer'>
      ©️ PomoDoro Web App. All rights are reserved by Pratham Saxena.
    </div>
  )
}
